import angular from 'angular';

class confirmationExportFollowupModalCtrl {
    /* @ngInject */
    constructor($translate, PrincipalSvc, CONF) {
        this.$translate = $translate;
        this.PrincipalSvc = PrincipalSvc;
        this.CONF = CONF;
    }

    $onInit() {
        this.principal = angular.copy(this.resolve.principal);
        this.type = angular.copy(this.resolve.type);
        this.title = 'principal.' + this.type + '.invited_followup.title';
        this.text = 'principal.' + this.type + '.invited_followup.text';

        this.displayForm = false;
        this.displayLoad = false;
        this.displayResult = false;

        this.manageDisplay('form');
    }

    cancel() {
        this.modalInstance.dismiss();
    }

    confirm_all_clients() {
        this.modalInstance.close(false);
    }

    confirm_all_clients_without_email() {
        this.modalInstance.close(true);
    }

    exportFollowup(considerOnlyNullEmails) {
        this.manageDisplay('load');
        this.PrincipalSvc.exportInvitedBuyersFollowUp(this.PrincipalSvc.getPrincipalId(), considerOnlyNullEmails).then(
            result => {
                this.progressTitle = this.$translate.instant(this.title);
                this.displayProgress = true;
                this.taskId = result;
            },
            error => {
                if (error.status === 400 && error.data && error.data.code === 'OPERATION_ALREADY_IN_EXECUTION') {
                    this.logger.error('error.operation_already_inprogress');
                    this.cancel();
                } else {
                    this.logger.error('error.export_followup');
                    this.manageDisplay('form');
                }
            }
        );
    }

    getStagedFileName(fileHeaderId) {
        const { apiContext, apiBaseUrl } = this.CONF;
        return apiContext + apiBaseUrl + '/v1/staged-files/' + fileHeaderId;
    }

    onTaskEnd(results) {
        this.displayProgress = false;
        if (results) {
            this.manageDisplay('result', this.type);

            const { result } = results;
            this.filePath = this.getStagedFileName(result);
            window.open(this.filePath, '_self');
        }
        this.modalInstance.close(true);
    }

    manageDisplay(step, type) {
        switch (step) {
            case 'form':
                this.displayForm = true;
                this.displayLoad = false;
                this.displayResult = false;
                break;
            case 'load':
                this.displayForm = false;
                this.displayLoad = true;
                this.displayResult = false;
                break;
            case 'result':
                this.title = 'principal.' + type + '.result.title';
                this.displayForm = false;
                this.displayLoad = false;
                this.displayResult = true;
                break;
        }
    }
}

angular.module('app.principal').component('confirmationExportFollowupModal', {
    templateUrl: require('./modal-export-followup-confirmation.html'),
    controller: confirmationExportFollowupModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
    },
});
